<template>
  <div>
    <b-tabs pills small class="mt-n1-0">
      <b-tab title="Domains" active>
        <HotspotsTable
          :url="domainNodesUrl"
          :timeRange="timeRange"
        ></HotspotsTable>
      </b-tab>
      <b-tab title="Inter-Domain Links">
        <HotspotsTable
          :url="domainLinksUrl"
          :timeRange="timeRange"
        ></HotspotsTable>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import HotspotsTable from '@/xvisor/components/launchPad/HotspotsTable.vue';

export default {
  components: {
    HotspotsTable,
  },
  data() {
    return {
      domainNodesUrl: '/apps/hotspots/nodelist.json',
      domainLinksUrl: '/apps/hotspots/linklist.json',
    };
  },
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
  },
};
</script>
